import React, { useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";

const tasks = [
  { name: "Pray Fajer", days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"] },
  { name: "Pray Duhur", days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"] },
  { name: "Pray Aser", days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"] },
  { name: "Pray Maghreb", days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"] },
  { name: "Pray Isha", days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"] },
  { name: "Make bed", days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"] },
  { name: "Brush Teeth (2 times, otherwise don't tick)", days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"] },
  { name: "Tidy up house (bag/shoes/clothes/dishwasher)", days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"] },
  { name: "Change underwear", days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"] },
  { name: "Shower", days: ["Monday", "Wednesday", "Friday", "Sunday"] },
  { name: "Cut Nails", days: ["Sunday"] },
  { name: "Read Quraan", days: ["Tuesday", "Friday", "Sunday"] },
  { name: "Read Arabic (15 mins)", days: ["Monday", "Thursday", "Saturday", "Sunday"] },
  { name: "Laundry", days: ["Saturday", "Sunday"] },
  { name: "Clean the house and tidy up my room", days: ["Sunday"] },
  { name: "Submit the task paper & write the points", days: ["Sunday"] },
  { name: "Soccer Practice", days: ["Monday", "Wednesday", "Friday"] },
  { name: "Learn and experiment about something AI", days: ["Saturday"] },
  { name: "Learn Google Sheets", days: ["Thursday"] },
  { name: "Learn a new valuable and interesting knowledge/skill", days: ["Friday"] },
  { name: "Do the MoneyTime course", days: ["Tuesday"] },
  { name: "Science Experiment (kiwi crate)", days: ["Sunday"] }
];

const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

export default function YaserTaskTracker() {
  const [completed, setCompleted] = useState({});
  const [behaviorPoints, setBehaviorPoints] = useState({});

  const toggleTask = (day, task) => {
    const key = `${day}_${task}`;
    setCompleted(prev => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleBehaviorChange = (day, value) => {
    setBehaviorPoints(prev => ({
      ...prev,
      [day]: Number(value),
    }));
  };

  const calculateTaskPoints = () => {
    return Object.values(completed).filter(Boolean).length;
  };

  const totalBehaviorPoints = Object.values(behaviorPoints).reduce((sum, val) => sum + val, 0);
  const totalPoints = calculateTaskPoints() + totalBehaviorPoints;
  const weeklyAllowance = (totalPoints * 0.2).toFixed(2);

  const getTaskCompletionData = () => {
    return tasks.map(task => {
      const count = task.days.reduce((acc, day) => acc + (completed[`${day}_${task.name}`] ? 1 : 0), 0);
      return { name: task.name, count };
    }).sort((a, b) => b.count - a.count).slice(0, 5);
  };

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Yaser's Weekly Task Tracker</h1>

      <div className="mb-6">
        <h2 className="text-xl font-semibold mb-2">Top Completed Tasks</h2>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={getTaskCompletionData()} layout="vertical">
            <XAxis type="number" allowDecimals={false} />
            <YAxis dataKey="name" type="category" width={200} />
            <Tooltip />
            <Bar dataKey="count" fill="#4ade80" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div className="overflow-auto">
        <table className="table-auto border-collapse border border-gray-300 w-full text-sm">
          <thead>
            <tr>
              <th className="border border-gray-300 p-2">Task</th>
              {days.map(day => (
                <th key={day} className="border border-gray-300 p-2">{day}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tasks.map((task, index) => (
              <tr key={task.name} className={index % 2 === 0 ? 'bg-yellow-100' : 'bg-yellow-200'}>
                <td className="border border-gray-300 p-2 font-medium">{task.name}</td>
                {days.map(day => {
                  const isAssigned = task.days.includes(day);
                  const bgColor = isAssigned ? (index % 2 === 0 ? 'bg-yellow-100' : 'bg-yellow-200') : 'bg-yellow-300';
                  return (
                    <td
                      key={day}
                      className={`border border-gray-300 p-2 text-center ${bgColor}`}
                    >
                      {isAssigned ? (
                        <input
                          type="checkbox"
                          className="w-6 h-6"
                          checked={!!completed[`${day}_${task.name}`]}
                          onChange={() => toggleTask(day, task.name)}
                        />
                      ) : null}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="mt-6">
        <h2 className="text-xl font-semibold mb-2">Behavior Points Per Day</h2>
        <table className="table-auto border-collapse border border-gray-300 text-sm mb-4">
          <thead>
            <tr>
              {days.map(day => (
                <th key={day} className="border border-gray-300 p-2">{day}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              {days.map(day => (
                <td key={day} className="border border-gray-300 p-2">
                  <input
                    type="number"
                    value={behaviorPoints[day] || 0}
                    onChange={e => handleBehaviorChange(day, e.target.value)}
                    className="w-16 p-1 border border-gray-300 rounded"
                  />
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>

      <div className="mt-6 text-lg font-semibold">
        <span role="img" aria-label="checkmark">✅</span> Task Points: {calculateTaskPoints()}<br />
        <span role="img" aria-label="star">🌟</span> Behavior Points: {totalBehaviorPoints}<br />
        <span role="img" aria-label="total">🔢</span> Total Points: {totalPoints}<br />
        <span role="img" aria-label="money">💸</span> Weekly Allowance: ${weeklyAllowance}
      </div>
    </div>
  );
}